import MembershipModelBase from '../_generated/modelBases/membership-model-base';

export default class MembershipModel extends MembershipModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
